import { observer } from '~/common/mobx.decorator'
import { Box, Dialog, Grid, SvgIcon, Typography } from '@material-ui/core'
import { appStore, routerStore } from '~/stores'
import { PATHS } from '~/common/constants'
import React from 'react'
import { careJobDetailStore } from '~/features/care-jobs/detail/care-job-detail.store'
import { quickApplyModalStyled } from '~/features/quick-apply/quick-apply-component.style'
import { CloseIconDialog } from '~/components/icons'
import { Button } from '~/components/button'
import { careHomeStore } from '~/features/care-home/care-home.store'

export const SuccessCheckinDialog = observer(() => {
	const { currentCheckoutItem } = careHomeStore
	const { isShowCheckoutSuccess, setIsShowCheckoutSuccess } = careJobDetailStore
	return (
		<Dialog open={isShowCheckoutSuccess} onClose={() => setIsShowCheckoutSuccess(false)} css={quickApplyModalStyled}>
			<Box style={{ maxWidth: 396 }} m={2}>
				<Grid container className="wrap-title">
					<Grid item xs={11} className="title">
						<Typography>You've checked out of this assignment</Typography>
					</Grid>
					<div
						onClick={() => setIsShowCheckoutSuccess(false)}
						style={{
							position: 'absolute',
							top: 15,
							right: 15,
							cursor: 'pointer',
						}}
					>
						<SvgIcon component={CloseIconDialog} />
					</div>

					<Grid item xs={12}>
						<Typography
							css={[
								appStore.getTheme.typography.h4,
								{
									color: appStore.getTheme.colors.content.dark,
									margin: '10px 0',
									fontWeight: 500,
								},
							]}
						>
							Your work time has be logged on your timecard.
						</Typography>
					</Grid>
				</Grid>
				<Grid container spacing={2}>
					<Grid style={{ marginTop: 10, marginBottom: 10 }} item justify="space-between" container>
						<Grid item xs={12} style={{ marginTop: 8 }}>
							<Button
								type="button"
								onClick={async () => {
									await setIsShowCheckoutSuccess(false)
									await routerStore.goPage(`${PATHS.care.timecards}/${currentCheckoutItem?.id}`)
								}}
							>
								View my timecard
							</Button>
						</Grid>
						<Grid item xs={12} style={{ marginTop: 8 }}>
							<Button onClick={() => setIsShowCheckoutSuccess(false)} variant="outlined" type="button">
								Close
							</Button>
						</Grid>
					</Grid>
				</Grid>
			</Box>
		</Dialog>
	)
})
